<section class="contact-wrap">
  <div class="wrap-lg">
    <div class="contact-inner">
      <div class="nav-sec" >
        <div class="back-nav" (click)="goTohome()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="nav-name" >Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">Contact Us</div>
        </div>
      </div>
      <div class="box-tab">
        <div class="tab-sec">
          <div class="primary-tab">
            <div class="tab-item" [class.active]="contactTab == 'call'" (click)="contactTab = 'call'">Call Us</div>
            <div class="tab-item" [class.active]="contactTab == 'mail'" (click)="contactTab = 'mail'">Write to Us</div>
          </div>
        </div>
        <div class="tab-content">
          <div *ngIf="contactTab == 'call'" class="contact-inner">
            <div class="gradient-line"></div>
            <div class="left">
              <div class="ico-sec"><img src="assets/images/contact/call.svg" alt="call us"/></div>
            </div>
            <div class="right">
              <div class="contact-title">Call Us</div>
              <div class="contact-info">to our toll-free number</div>
              <div class="contact-link">
                <svg width="33" height="33" viewBox="0 0 33 33" fill="none">
                  <g id="Call">
                  <path id="Vector" d="M9.88777 8.00439H13.6545L15.5379 12.7128L13.1837 14.1254C14.1922 16.1703 15.8472 17.8253 17.8921 18.8338L19.3047 16.4796L24.0131 18.363V22.1297C24.0131 22.6292 23.8147 23.1083 23.4615 23.4615C23.1083 23.8147 22.6292 24.0131 22.1297 24.0131C18.4565 23.7899 14.9919 22.23 12.3897 19.6278C9.78749 17.0256 8.22762 13.5611 8.00439 9.88777C8.00439 9.38827 8.20282 8.90923 8.55602 8.55602C8.90923 8.20282 9.38827 8.00439 9.88777 8.00439" stroke="#10D7EE" stroke-width="2.00109" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                </svg>
                <a [href]="'tel:' + resValue.mobile_no">{{resValue.mobile_no}}</a>
              </div>
            </div>
          </div>
          <div *ngIf="contactTab == 'mail'" class="contact-inner mail">
            <div class="gradient-line"></div>
            <div class="left">
              <div class="ico-sec"><img src="assets/images/contact/mail.svg" alt="call us"/></div>
            </div>
            <div class="right">
              <div class="contact-title">Write to us</div>
              <div class="contact-info">to our customer support</div>
              <div class="contact-link">
                <svg width="33" height="32" viewBox="0 0 33 32" fill="none">
                  <g id="Mail 2">
                  <path id="Vector" d="M8.25012 8H24.7511C25.8855 8 26.8137 8.90005 26.8137 10.0001V22.0008C26.8137 23.1009 25.8855 24.0009 24.7511 24.0009H8.25012C7.11568 24.0009 6.1875 23.1009 6.1875 22.0008V10.0001C6.1875 8.90005 7.11568 8 8.25012 8Z" stroke="#10D7EE" stroke-width="2.00121" stroke-linecap="round" stroke-linejoin="round"/>
                  <path id="Vector_2" d="M26.8137 10.0005L16.5006 17.0009L6.1875 10.0005" stroke="#10D7EE" stroke-width="2.00121" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                </svg>
                <a [href]="'mailto:' + resValue.email">{{resValue.email}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
